import { DynamicQuestion } from '@common/dynamic-form/types';
import { doesObjectContainNonEmptyValues, isAnswerEmpty } from '@common/utils';
import { formatDateWithoutTime } from '@common/utils/date-utils';
import { toNumber } from 'lodash';
import { HeraldSchemaFormat } from 'clients/types';

export function removeEndingAfterUnderscore(str: string) {
  const lastIndex = str.lastIndexOf('_');
  if (lastIndex !== -1) {
    return str.substring(0, lastIndex);
  }
  return str; // No underscore found, return original string
}

export function normalizeDynamicFormValueAccordingToSchema(value: any, schema: DynamicQuestion['schema']) {
  // if user deleted all text field then we send null in order to reset the value
  if (isAnswerEmpty(value)) {
    return null;
  }

  if (schema) {
    if (['integer', 'number'].includes(schema.type)) {
      return toNumber(value);
    }
    if (schema.format === HeraldSchemaFormat.Date) {
      return formatDateWithoutTime(value, 'YYYY-MM-DD');
    }

    if (schema.type === 'object') {
      return doesObjectContainNonEmptyValues(value)
        ? // normalizing properties values inside object
          Object.keys(value).reduce((acc, curr) => {
            // @ts-ignore
            acc[curr] = normalizeDynamicFormValueAccordingToSchema(value[curr], schema.properties![curr]);
            return acc;
          }, {})
        : // object is empty send null instead of object with empty properties
          null;
    }
  }

  return value;
}
